import url from 'url'
import { useCallback, useEffect } from 'react'
import { useRouter } from 'next/router'
import { omit } from 'ramda'

import { isEmptyOrNull } from '@/utils'
import { stringify } from '@/utils/qs'
import useCurrentSession from '@/hooks/use-current-session'
import useFormattedFilters from '@/hooks/use-formatted-filters'

const useCreateListingAlert = showAlertModal => {
  const router = useRouter()
  const createAlertQuery = router?.query?.create_alert
  const session = useCurrentSession()
  const filters = useFormattedFilters()
  const noCity = isEmptyOrNull(filters.cities)
  const isLandlord = session.user_type === 'landlord'
  const sessionLoaded = session.loaded
  const disabled = noCity || isLandlord

  const showModal = useCallback(() => {
    showAlertModal()
  }, [])

  useEffect(() => {
    if (!sessionLoaded || !router.isReady || !createAlertQuery || disabled) {
      return
    }

    if (createAlertQuery === 'true') {
      const queryString = stringify(omit(['create_alert'], router.query))
      const path = url.parse(router.asPath).pathname
      const withQuery = `${path}${queryString ? `?${queryString}` : ''}`
      router.replace(withQuery, withQuery, { shallow: true })
      showModal()
    }
  }, [router, sessionLoaded, createAlertQuery, disabled, showModal])

  return null
}

export default useCreateListingAlert
